import React, { useEffect } from "react";

// Using props with RouteComponentProps pattern for v5
const ReferralHandler = (props) => {

  
  // Extract referral code from match params
  const referralCode = props.match.params.referralCode;
  
  useEffect(() => {
    // Save the referral code to local storage
    if (referralCode) {
      localStorage.setItem("referralCode", referralCode);
      console.log(`Referral code ${referralCode} saved to local storage`);
    }
    // Stay on the host the link was opened on. localStorage is per-domain, so
    // bouncing a whitelabel visitor to core.mploi.com would lose the code and
    // land them on the wrong site.
    window.location.href = `${window.location.origin}/accounts/signup`;
  }, [referralCode]);

  // Return null or a loading indicator while redirecting
  return <div>Redirecting...</div>;
};

export default ReferralHandler;